module.exports = __webpack_public_path__ + "img/3_ar.ae2a4a05.png";